export default "__VITE_ASSET__BdEozWqw__"